import { Link, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { H5SubPageShell } from "../components/common/H5SubPageShell";
import {
  h5LegalUrl,
  openH5LegalPath,
  resolveLegalBackPath,
  sanitizeH5BackPath,
} from "../login/legalLinks";
import { h5NavigateTo } from "../utils/miniProgramEnv";
import {
  H5_LEGAL_DOCS,
  H5_LEGAL_NAV_SLUGS,
  H5_LEGAL_TITLES,
  isH5LegalSlug,
} from "./h5LegalContent";
import "./LegalDocPage.css";

/** H5 法规文档页：用户协议 / 隐私政策 / 法律合规 */
export default function LegalDocPage() {
  const { slug = "" } = useParams<{ slug: string }>();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const known = isH5LegalSlug(slug);
  const title = known ? H5_LEGAL_TITLES[slug] : "文档";
  const doc = known ? H5_LEGAL_DOCS[slug] : null;
  const stateBack =
    location.state && typeof location.state === "object" && "back" in location.state
      ? (location.state as { back?: unknown }).back
      : undefined;
  /**
   * 返回路径：query / state / sessionStorage / 首页兜底。
   * 按钮走显式 back；有 history 时系统右滑也会 pop。
   */
  const backTo = resolveLegalBackPath({
    queryBack: searchParams.get("back"),
    stateBack,
  });

  const onBack = () => {
    h5NavigateTo(navigate, backTo, { replace: true });
  };

  return (
    <H5SubPageShell title={title} onBack={onBack}>
      <div className="legal-doc-page">
        {doc ? (
          <article className="legal-doc-page__article">
            <p className="legal-doc-page__updated">更新日期：{doc.updatedAt}</p>
            {doc.preamble?.map((paragraph) => (
              <p key={paragraph} className="legal-doc-page__p">
                {paragraph}
              </p>
            ))}
            {doc.sections.map((section) => (
              <section key={section.heading} className="legal-doc-page__section">
                <h2 className="legal-doc-page__h2">{section.heading}</h2>
                {section.paragraphs.map((paragraph) => (
                  <p key={paragraph} className="legal-doc-page__p">
                    {paragraph}
                  </p>
                ))}
              </section>
            ))}
            <nav className="legal-doc-page__nav" aria-label="相关文档">
              {H5_LEGAL_NAV_SLUGS.map((navSlug) => (
                <Link
                  key={navSlug}
                  className={
                    navSlug === slug
                      ? "legal-doc-page__nav-link legal-doc-page__nav-link--current"
                      : "legal-doc-page__nav-link"
                  }
                  to={h5LegalUrl(navSlug, { back: sanitizeH5BackPath(backTo) })}
                  onClick={(e) => {
                    if (navSlug === slug) {
                      e.preventDefault();
                      return;
                    }
                    e.preventDefault();
                    h5NavigateTo(navigate, openH5LegalPath(navSlug, backTo), {
                      state: { back: backTo },
                    });
                  }}
                >
                  {H5_LEGAL_TITLES[navSlug]}
                </Link>
              ))}
            </nav>
          </article>
        ) : (
          <p className="legal-doc-page__empty">文档不存在。</p>
        )}
      </div>
    </H5SubPageShell>
  );
}
